import { inject as service } from '@ember/service';
import Controller from '@ember/controller';
import { EMBER_ROUTE_NAMES } from '../../../constants/routes';

/** @module */
const CreatorSignupBackgroundController = Controller.extend({
  router: service(),
  session: service(),

  /** @type {Ember.Service} */
  userCommandService : service('commands/user-commands'),

  /** @inheritDoc */
  actions: {
    /**
     * @param {Object} v
     * @param {string} v.description
     * @param {string} v.personal_website
     * @param {boolean} v.intercountry_travel
     * @param {Ember.A} v.equipment,
     * @param {Ember.A} v.languages
     */
    updateUser({
      description,
      equipment,
      languages,
      personal_website: personalWebsite,
      intercountry_travel: intercountryTravel,
    }) {
      const {
        userCommandService,
        'model.user': user,
        'model.profile': profile,
      } = this.getProperties([
        'userCommandService',
        'model.user',
        'model.profile',
      ]);


      const userProps = { description };
      const profileProps = { intercountryTravel, personalWebsite };
      const profileRelationships = { equipment, languages };

      const userSave = userCommandService.updateUser(user, userProps, {});
      const profileSave = userCommandService.updateUserProfile(user, profile, profileProps, profileRelationships);

      return Promise.all([userSave, profileSave]).then(() => {
        return this.session.loadCurrentUser();
      }).then(() => {
        this.router.transitionTo(EMBER_ROUTE_NAMES.SIGNUP__STEP__WORK);
      });
    },
  },
});

export default CreatorSignupBackgroundController;
